import React, { useState } from "react";
import { Card, Form, Row, Col, Button, Alert } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { loginPartner } from "./services/partnerAuthService";

const getErr = (err, fallback) => err.response?.data?.error || fallback;

export default function PartnerLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) return setError("Please enter both email and password");

    setLoading(true);
    try {
      const { data } = await loginPartner(email.trim().toLowerCase(), password);
      localStorage.setItem("partner_token", data.token);
      localStorage.setItem("partner_profile", JSON.stringify(data.data));
      navigate("/partner/dashboard");
    } catch (err) {
      setError(getErr(err, "Login failed. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center agent-login-container">
      <Card className="agent-login-card w-100" style={{ maxWidth: "480px" }}>
        <Row>
          <Col className="d-flex flex-column justify-content-center agent-login-right-panel px-4 py-4">
            <div className="text-center mb-3">
              <h2 className="fw-bold text-light">Partner Login</h2>
              <p className="text-light">Sign in to manage your travel business on Bachatwali Ticket</p>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3">
                <Form.Label className="text-light">Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="you@business.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="text-light">Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              <Button type="submit" className="w-100 login-btn mb-2" disabled={loading}>
                {loading ? "Signing in…" : "Login as Partner"}
              </Button>
              <div className="text-center mt-3">
                <span className="text-light">
                  New business? <Link to="/partner/register">Join Bachatwali Ticket as a Partner — it's free</Link>
                </span>
              </div>
            </Form>
          </Col>
        </Row>
      </Card>
    </div>
  );
}
